import type { Origin } from '@/components/Learn/types'
import { APIClient } from "@/services"
import { lessonStore } from '@/stores'
import { Chapter } from "@/types"
import { TypeGuards } from '@codeleap/types'
import { navigate } from "gatsby"

const LIMIT_OF_FREE_LESSONS = 1

function getStoredLesson(id: Chapter['id']): { index: number; id: Chapter['id']; isCompleted: boolean } {
  const openedLessons = lessonStore.getOpenedLessons()
  const index = openedLessons.findIndex(l => l?.id === id)

  if (index === -1) return null
  return { index, ...openedLessons[index] }
}

export function updateLessonsOpenedCount(lesson: Chapter) {
  if (APIClient.Session.isLoggedIn()) return

  const openedLessons = lessonStore.getOpenedLessons()

  const storedLesson = getStoredLesson(lesson.id)

  if (storedLesson) {
    openedLessons[storedLesson.index] = { id: lesson.id, isCompleted: lesson.done }
  } else {
    openedLessons.push({ id: lesson.id, isCompleted: lesson.done })
  }

  lessonStore.setOpenedLessons(openedLessons)
}

export function canOpenLesson(id: Chapter['id']): boolean {
  if (APIClient.Session.isLoggedIn()) return true

  const storedLesson = getStoredLesson(id)

  if (storedLesson) {
    return !storedLesson?.isCompleted
  }

  return lessonStore.getOpenedLessons()?.length < LIMIT_OF_FREE_LESSONS
}

export function tryOpenLesson(id: Chapter["id"], initialPage = null, origin: Origin = 'learn') {
  if (!canOpenLesson(id)) {
    APIClient.UnknownProfile.maybeOpenRegistrationWall()
    return
  }

  let route = `/learn/lessonView/${id}`

  route = route + `?origin=${origin}`

  if (TypeGuards.isNumber(initialPage)) {
    route = route + `&page=${initialPage}`
  }

  navigate(route as never)
}
